import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const STORAGE_KEY = "oes_institute";
const InstituteContext = createContext(null);

export const useInstitute = () => {
  const ctx = useContext(InstituteContext);
  if (!ctx) throw new Error("useInstitute must be used inside <InstituteProvider>");
  return ctx;
};

export function InstituteProvider({ children }) {
  const [currentInstitute, setState] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY));
    } catch {
      return null;
    }
  });

  const setCurrentInstitute = useCallback((inst) => {
    setState(inst);
    try {
      if (inst) localStorage.setItem(STORAGE_KEY, JSON.stringify(inst));
      else localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* storage unavailable — keep in-memory state only */
    }
  }, []);

  const logout = useCallback(() => setCurrentInstitute(null), [setCurrentInstitute]);

  const value = useMemo(
    () => ({ currentInstitute, setCurrentInstitute, logout }),
    [currentInstitute, setCurrentInstitute, logout]
  );

  return <InstituteContext.Provider value={value}>{children}</InstituteContext.Provider>;
}